import store from "@/store";

/**
 * @param {Function|null} callback - Optional callback function
 * @param {boolean} singleMode - Whether to scan a single QR code
 * @param {Object} additionalData - Additional data to pass
 * @param {String} customCommand - Custom command to use
 * @constructor
 */
var MobileDeviceBridgeScanQrHandler = function (callback, singleMode = true, additionalData = {}, customCommand) {

    /**
     * @returns {Promise<{value: String|undefined, command: String}>}
     */
    this.invokeNotification = async function () {
        let command = customCommand ? customCommand : singleMode ? 'SCAN_ONE_QR' : 'SCAN_QR';
        let response = { 
            command, 
            instance: window.location.href, 
            ...additionalData 
        };
        
        if (typeof callback === 'function') {
            let taskId = await store.dispatch('mobileWrapperTasks/setTask', { callback });
            response.value = taskId;
        }
        
        return response;
    }
}

export default MobileDeviceBridgeScanQrHandler;